import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { subscriptionFeatureKey, subscriptionReducer, SubscriptionEffects } from '@store/subscription';


@NgModule({
  imports: [
    StoreModule.forFeature(subscriptionFeatureKey, subscriptionReducer),
    EffectsModule.forFeature([ SubscriptionEffects ]),
  ],
  exports: [
    StoreModule,
  ],
})
export class SubscriptionFeatureModule { }
